module.exports = __webpack_public_path__ + "static/media/445647917_1623495791773070_7629958413303954037_n-min.4441ddfe.jpg";